import {Component} from '@angular/core';
import {ComponentModalConfig, ModalSize, SuiModal} from '@angular-ex/semantic-ui';

interface IAlertModalContext {
  title: string;
  alert: string;
}


@Component({
  selector: 'app-alert-modal',
  templateUrl: './alert-modal.component.html',
  styleUrls: ['./alert-modal.component.css'],
  standalone: false,
})
export class AlertModalComponent {

  constructor(public modal: SuiModal<IAlertModalContext, void, void>) {
  }
}

export class AlertModal extends ComponentModalConfig<IAlertModalContext, void, void> {
  constructor(title: string, alert: string, size = ModalSize.Small) {
    super(AlertModalComponent, {title, alert});

    this.isClosable = true;
    this.transitionDuration = 200;
    this.size = size;
  }
}
